export const pending = 1;
export const approved = 2;
export const rejected = 3;

export const isPendingDoc = status => status === pending;
export const isApprovedDoc = status => status === approved;
export const isRejectedDoc = status => status === rejected;

export const docStatuses = {
  pending: {
    id: 1,
    title: 'Pending',
    icon: 'hourglass'
  },
  approved: {
    id: 2,
    title: 'Approved',
    icon: 'ok'
  },
  rejected: {
    id: 3,
    title: 'Rejected',
    icon: 'remove'
  }
};

export function getDocStatus(statusId) {
  switch (statusId) {
    case pending:
      return docStatuses.pending;
    case approved:
      return docStatuses.approved;
    case rejected:
      return docStatuses.rejected;
    default:
      return docStatuses.pending;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/DocumentStatus.js